<div fxLayout="column" fxLayoutGap="15px" class="inner-card pt-25 pb-25 pl-15 pr-15">
    <span class="txt-h-16-7">{{isStatisticalProfile ? ('Statistical profile'|i18n) : ('Predictive model'|i18n)}}</span>
    <div fxLayout="row" fxLayoutAlign="center center" class="set-gap">
        <span fxFlex.gt-sm="40" fxFlex.xs="0" class="txt-p-16-4 text-end">{{isStatisticalProfile ? ('Statistical profile'|i18n) : ('Predictive model'|i18n)}}:{{isRequired ? '*' : ''}}</span>

        <div fxFlex.gt-sm="60" fxFlex.xs="100">
            <ng-container *ngIf="!statisticalProfile && mode === WizardPodCardMode.STATISTICAL_PROFILE || !predictiveModel && mode === WizardPodCardMode.PREDICTIVE_MODEL">
                <button app-ghost-button
                        class="fix-button"
                        (click)="openDialog()">
                    <span>{{isStatisticalProfile ? ('Configure statistical profile'|i18n) : ('Configure predictive model'|i18n)}}</span>
                    <app-icon class="right-icon" name="fal-chart-network"></app-icon>
                </button>
            </ng-container>

            <ng-container *ngIf="statisticalProfile && mode === WizardPodCardMode.STATISTICAL_PROFILE || predictiveModel && mode === WizardPodCardMode.PREDICTIVE_MODEL">
                <div fxLayout="row" fxLayoutAlign="start center" class="set-gap">
                    <ng-container *ngIf="predictiveModel && mode === WizardPodCardMode.PREDICTIVE_MODEL">
                        <span *ngIf="predictiveModel.type === ModelType.PV" class="text-bold">
                            {{'Photovoltaic'|i18n}}
                        </span>
                        <span *ngIf="predictiveModel.type === ModelType.WIND" class="text-bold">
                            {{'Wind'|i18n}}
                        </span>
                    </ng-container>
                    <ng-container *ngIf="statisticalProfile && mode === WizardPodCardMode.STATISTICAL_PROFILE">
                        <span *ngIf="statisticalProfileResource.type === StatisticalProfileResourceType.PV_PLANT" class="text-bold">
                            {{'Photovoltaic plant'|i18n}}
                        </span>
                        <span *ngIf="statisticalProfileResource.type === StatisticalProfileResourceType.WIND_PLANT" class="text-bold">
                            {{'Wind plant'|i18n}}
                        </span>
                        <span *ngIf="statisticalProfileResource.type === StatisticalProfileResourceType.POD" class="text-bold">
                            {{currentEnergyProfile|i18n}}, {{statisticalProfilePod.user_type|userType|i18n}}, {{statisticalProfilePod.rate_mode|radioRateMode|i18n}}
                        </span>
                    </ng-container>
                    <button app-small-ghost-button
                            (click)="openDialog()">
                        <app-icon class="fix-margin" name="fal-pencil-alt"></app-icon>
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
    <div fxLayout="row" class="w-100 fix-responsive set-gap">
        <div fxFlex.gt-sm="40" fxFlex.xs="0"></div>
        <span fxFlex.gt-sm="60" fxFlex.xs="100" class="txt-s-14-4">{{isStatisticalProfile ?
            ('The use of statistical data is conditional on the use of monitored data'|i18n) :
            ('The model is preset. Edit if necessary'|i18n)}}.
        </span>
    </div>
</div>


<ng-template #setParameter let-data let-close="close">
    <h1 mat-dialog-title class="txt-h-30-7">{{isStatisticalProfile ? ('Statistical profile'|i18n) : ('Predictive model'|i18n)}}</h1>
    <div mat-dialog-content fxLayout="column" class="param-dialog">
        <form novalidate [formGroup]="data.form" fxLayout="column">
            <app-statistical-profile *ngIf="isStatisticalProfile"
                                     [resource]="statisticalProfileResource"
                                     [resetValueProvider]="resetValueProvider"
                                     formControlName="param">
            </app-statistical-profile>
            <app-predictive-model *ngIf="!isStatisticalProfile"
                                  [resource]="predictiveModelResource"
                                  [resetValueProvider]="resetValueProvider"
                                  formControlName="param">
            </app-predictive-model>
        </form>
    </div>
    <div mat-dialog-actions class="mt-16" fxLayout="row" fxLayoutAlign="center center">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data.form.valid || !data.form.dirty"
                (click)="close(data.form.controls.param.value)">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Ok'|i18n}}
        </button>
    </div>
</ng-template>
